// ============ إعدادات Firebase (الليدز + إحصائيات الزوار + الداشبورد) ============
// 1) من Firebase Console > Project settings > General > Your apps > Web app انسخ القيم دي وحطها هنا.
// 2) لحد ما تملاهم، الموقع شغال عادي بس مش بيسجل ليدز ولا زيارات، والداشبورد بتعرض بيانات تجريبية.
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyB8ezUW7b4fdMkNhJU14zAh4gLNWpbR0-8",
  authDomain: "helmax-realestate.firebaseapp.com",
  projectId: "helmax-realestate",
  appId: "1:782085047272:web:805aaa3511aa7173a65a5d",
};

// الإيميلات المسموح لها تدخل الداشبورد (لازم تكون نفس الإيميلات في firestore.rules)
// الباسوردات مش مكتوبة هنا: بتتعمل مع الحسابات في Firebase Console > Authentication > Users
export const ADMIN_EMAILS = ["admin@helmaxrealestate.com", "dev@gmail.com"];

export const isFirebaseConfigured = () => Boolean(FIREBASE_CONFIG.apiKey && FIREBASE_CONFIG.projectId);

// للتجربة على الجهاز بس: true = يسجّل الزيارات وانت شغال على localhost
export const TRACK_LOCALHOST = false;

// كل التواريخ في الداشبورد بتوقيت دبي
export const TIME_ZONE = "Asia/Dubai";
